
import React from 'react';
import SettingsSlider from './SettingsSlider';

function SettingsSliderContainer(props) {
    return (<SettingsSlider {...props} />);
}

export default SettingsSliderContainer;